/* GYMSKYNS wishlist — localStorage-persisted heart toggle (header badge + product card/product page hearts) */
(function () {
  var STORAGE_KEY = 'gymskyns:wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }

  function updateCountBadge() {
    var badge = document.getElementById('wishlistCount');
    if (!badge) return;
    var n = getWishlist().length;
    badge.textContent = n;
    badge.classList.toggle('is-hidden', n === 0);
    badge.classList.remove('bump');
    requestAnimationFrame(function () {
      badge.classList.add('bump');
    });
  }

  function syncButtonStates() {
    var ids = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', !!id && ids.indexOf(id) !== -1);
    });
  }

  function toggleProduct(btn) {
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    var ids = getWishlist();
    var index = ids.indexOf(id);
    var isActive = index === -1;

    if (isActive) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    saveWishlist(ids);

    document.querySelectorAll('[data-wishlist-toggle][data-product-id="' + id + '"]').forEach(function (match) {
      match.classList.toggle('is-active', isActive);
    });
    updateCountBadge();

    var name = btn.getAttribute('data-product-name');
    if (name && typeof window.GYMSKYNS_showCartToast === 'function') {
      window.GYMSKYNS_showCartToast(name + (isActive ? ' — Added to wishlist' : ' — Removed from wishlist'));
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggleProduct(btn);
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncButtonStates();
    updateCountBadge();
  });
})();
